require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/product-filters/workshop-product-filters.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/product-filters/workshop-product-filters.legacy.js
// module id = 706
// module chunks = 31